import { is } from '../xenv';
import { fusionGetSystemInfo } from '../platform/xenv/_common';
import { bridge } from '../platform';
import { compareVersion } from '../version';
import { getStorage } from '../storage';
/**
 * 物理像素转换为px单位
 * @param physicalPx 物理像素
 * @returns px
 */
const physicalPx2px = (physicalPx) => {
    const pixelRatio = window?.devicePixelRatio || 2;
    const cssPx = physicalPx / pixelRatio;
    return cssPx;
};
const baseGetNativeBottomNavSafeHeight = async (envInfo) => {
    const { appVersion, isAndroid, isIOS } = envInfo;
    // 端最高底导高度（模糊值），单位px
    const nativeBottomNavMaxHeightMap = {
        MAX_IOS: 96,
        MAX_ANDROID: 80,
    };
    // 默认无需适配
    let maxHeight = 0;
    // 分端适配
    if (isIOS) {
        // iOS 只要是底导就需要适配底部高度
        maxHeight = nativeBottomNavMaxHeightMap.MAX_IOS;
    }
    else if (isAndroid) {
        // Android
        if (appVersion) {
            const needAdapt = compareVersion(appVersion, '6.7.12') >= 0 ||
                compareVersion(appVersion, '6.6.4') < 0;
            if (needAdapt) {
                maxHeight = nativeBottomNavMaxHeightMap.MAX_ANDROID;
            }
        }
    }
    return maxHeight;
};
/**
 * 获取乘客端底导最大安全高度
 * @returns px
 */
const getNativeBottomNavSafeHeight = async () => {
    const { appversion: appVersion } = await fusionGetSystemInfo();
    return baseGetNativeBottomNavSafeHeight({
        appVersion,
        isAndroid: is('android'),
        isIOS: is('ios'),
    });
};
/**
 * 获取乘客端底导精确高度
 * @returns px
 */
const getNativeBottomNavExactHeight = async () => {
    return new Promise((resolve) => {
        if (bridge?.getHomeBottomNavHeight) {
            // 原始返回值单位为物理像素，须转换
            bridge.getHomeBottomNavHeight({}, (res) => {
                console.log('====== getHomeBottomNavHeight res ======', res);
                resolve(physicalPx2px(res.bottomNavHeight));
            });
        }
        else {
            // 输出默认最大高度值
            getNativeBottomNavSafeHeight().then((maxHeight) => resolve(maxHeight));
        }
    });
};
/**
 * 获取乘客端高度
 * @param isExact 是否返回精确值
 * @returns px
 */
export const getBottomNavHeight = async (options) => {
    // 如果已经有server侧的执行结果，直接返回，保证SSR项目server/client侧返回值的一致性
    const serverBottomNavHeightRes = getStorage()?.viewInfo?.bottomNavHeight;
    if (serverBottomNavHeightRes !== null && serverBottomNavHeightRes !== undefined) {
        return serverBottomNavHeightRes;
    }
    const { isBottomNav: customIsBottomNav, isExact = false } = options || {};
    const ua = window?.navigator.userAgent;
    const isBottomNav = customIsBottomNav ?? (is('passenger') && ua?.includes('BottomBar/on'));
    console.log('====== 是否是底导 ======', isBottomNav);
    if (isBottomNav) {
        return isExact ? getNativeBottomNavExactHeight() : getNativeBottomNavSafeHeight();
    }
    else {
        return 0;
    }
};
